export const openSecondaryPanel = () => ({
	type: 'SHOW_SECONDARY',
})

export const closeSecondaryPanel = () => ({
	type: 'HIDE_SECONDARY',
})

